import { Container } from "@mui/material";

export default function Footer() {
    return <div className="bg-neutral-900 py-3 mt-auto">
        <Container maxWidth="lg" className=" text-gray-500 font-bold">
            © IFCL | <a className="text-gray-500 font-bold" href="/disclaimer">Disclaimer</a> | <a className="text-gray-500 font-bold" href="/privacy">Privacy</a> | <a className="text-gray-500 font-bold" href="/conditions">Conditions</a> | <a className="text-gray-500 font-bold" href="/delete-account">Delete Account</a>
        </Container>
    </div>
}